function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M248.861,333.503l125.867-141.611c4.54-5.112,6.827-11.682,6.426-18.509c-0.401-6.827-3.439-13.082-8.55-17.63 c-10.556-9.378-26.769-8.431-36.139,2.133L230.472,277.2l-29.303-33.749c-9.293-10.624-25.489-11.699-36.122-2.406 c-5.146,4.506-8.226,10.735-8.687,17.562c-0.452,6.827,1.775,13.414,6.281,18.569l49.161,56.183 c4.668,5.333,11.409,8.405,18.492,8.431h0.102C237.443,341.789,244.176,338.768,248.861,333.503z M230.361,324.722 c-2.219-0.009-4.25-0.939-5.717-2.611l-49.161-56.183c-1.502-1.707-2.244-3.908-2.091-6.187c0.154-2.27,1.178-4.352,2.893-5.854 c1.621-1.417,3.627-2.108,5.623-2.108c2.372,0,4.727,0.981,6.4,2.884l35.652,41.062c1.604,1.86,3.934,2.927,6.391,2.944 c2.671,0.188,4.796-1.033,6.426-2.867l112.444-126.583c1.51-1.707,3.601-2.714,5.871-2.85c2.338-0.196,4.471,0.632,6.17,2.142 c1.707,1.51,2.714,3.601,2.85,5.879c0.137,2.27-0.623,4.463-2.142,6.161L236.104,322.162 C234.627,323.826,232.469,324.364,230.361,324.722z"
}), React.createElement("path", {
  d: "M256,0C114.842,0,0,114.842,0,256s114.842,256,256,256s256-114.842,256-256S397.158,0,256,0z M256,494.933 C124.254,494.933,17.067,387.746,17.067,256S124.254,17.067,256,17.067S494.933,124.254,494.933,256S387.746,494.933,256,494.933 z"
}), React.createElement("path", {
  d: "M207.98,74.354c0.7,0,1.408-0.085,2.116-0.265c15.087-3.849,30.532-5.811,45.909-5.82 c4.719-0.009,8.533-3.831,8.525-8.542c0-4.71-3.823-8.525-8.533-8.525h-0.009c-16.794,0.009-33.655,2.15-50.116,6.349 c-4.565,1.161-7.322,5.811-6.153,10.385C200.701,71.794,204.174,74.354,207.98,74.354z"
}), React.createElement("path", {
  d: "M178.832,75.59c-2.048-4.25-7.159-6.025-11.401-3.985c-40.226,19.413-73.455,51.601-93.56,90.641 c-2.159,4.19-0.512,9.336,3.678,11.494c1.246,0.64,2.586,0.947,3.9,0.947c3.098,0,6.076-1.69,7.595-4.625 c18.415-35.772,48.896-65.271,85.803-83.081C179.097,84.934,180.872,79.831,178.832,75.59z"
}), React.createElement("path", {
  d: "M69.214,194.961c-4.54-1.254-9.25,1.391-10.513,5.931C53.734,218.761,51.209,237.303,51.2,256 c0,4.71,3.814,8.533,8.533,8.533c4.71,0,8.533-3.814,8.533-8.533c0.009-17.152,2.321-34.15,6.878-50.534 C76.407,200.926,73.754,196.224,69.214,194.961z"
}), React.createElement("path", {
  d: "M304.87,437.12c-16,4.378-32.444,6.605-48.87,6.613c-4.719,0-8.533,3.823-8.533,8.533c0,4.719,3.823,8.533,8.533,8.533 c17.954-0.009,35.908-2.441,53.367-7.219c4.548-1.246,7.228-5.939,5.982-10.479C314.103,438.554,309.376,435.866,304.87,437.12z"
}), React.createElement("path", {
  d: "M437.631,331.011c-4.267-2.005-9.353-0.145-11.341,4.13c-17.186,36.89-46.865,67.797-83.558,87.04 c-4.181,2.193-5.786,7.347-3.601,11.52c1.527,2.91,4.497,4.574,7.569,4.574c1.331,0,2.688-0.316,3.951-0.973 c39.996-20.975,72.354-54.69,91.11-94.959C443.75,338.069,441.898,333,437.631,331.011z"
}), React.createElement("path", {
  d: "M452.272,247.467h-0.009c-4.702,0-8.525,3.814-8.533,8.525c-0.008,14.609-1.672,29.099-4.958,43.059 c-1.075,4.591,1.775,9.182,6.366,10.266c0.657,0.154,1.306,0.222,1.954,0.222c3.874,0,7.373-2.654,8.303-6.579 c3.575-15.24,5.393-31.036,5.402-46.95C460.805,251.298,456.991,247.475,452.272,247.467z"
}))));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var Svg1 = function Svg1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/1.fe1bffa5.svg";
export { ForwardRef as ReactComponent };